const initialState = {
};

export default function akunReducer(state = initialState, action) {
  switch (action.type) {
  case 'POST_DATA_USER':
    return action.data;
  case 'GET_DATA_TABLE_AKUN':
    return {
      ...state,
      dataTable: action.data
    };
  default:
    return state;
  }
}